import { NavLink } from "react-router";
import TypeFrais from "../../components/TypeFrais/TypeFraisList";
import { useTrads } from "../../contexts/trads/useTrads";
function TypeFraisList(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink to={`/type_frais/add`} className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
    </nav>
    <TypeFrais   />
  </div>
  );
}
export default TypeFraisList;